// src/pages/InsuranceScreen.js
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../pages/Paymentscreen.css";
import Header_packages from "../components/Header_packages";
import Otp from "../components/otp";

const Otpscreen = () => {
  return (
    <div>
      <Header_packages title={`OTP Screen`} />
      <Otp />
    </div>
  );
};

export default Otpscreen;
